<template>
  <div class="container mx-auto" style="max-width: 1348px;">
    <div style="position: relative; width: 100%; padding-top: 56.22%;">
      <div class="w-full h-full absolute top-0">
        <iframe
          v-if="youtubeEnabled && currentLocale === 'it' && italianId"
          width="100%" height="100%"
          :src="`https://www.youtube.com/embed/${italianId}?rel=0`"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
        <iframe
          v-else-if="!youtubeEnabled && currentLocale === 'it' && italianId"
          width="100%" height="100%"
          :src="`https://www.youtube-nocookie.com/embed/${italianId}?rel=0`"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
        <iframe
          v-else-if="youtubeEnabled"
          width="100%" height="100%"
          :src="`https://www.youtube.com/embed/${id}?rel=0`"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
        <iframe
          v-else
          width="100%" height="100%"
          :src="`https://www.youtube-nocookie.com/embed/${id}?rel=0`"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useIubenda } from 'mars-iubenda-vite'
import { computed } from 'vue'

const props = defineProps<{
  id: string
  italianId?: string
}>()

const { youtubeEnabled } = useIubenda()
const { locale } = useI18n()
const currentLocale = computed(() => locale.value)
</script>

<style scoped></style>
